import { ProgramNames } from '@/models/Program';
import { UserType } from '@/models/User';
import { USCountryId } from '@/utils/constants';

export function buildReviewerAssignments(args: {
  type: UserType;
  email: string;

  // MultiSelect values (assumed { value })
  programIds: ProgramNames[];
  countryIds: number[];
  countyIds: string[];

  // domestic fields
  stateId?: string | null;
  countryId?: number; // if not provided, will default to USCountryId
}) {
  const { type, email, programIds, countryIds, countyIds, stateId, countryId } = args;

  const domesticCountryId = countryId ?? USCountryId;

  if (type === UserType.NationalProgrammeLead) {
    return programIds.flatMap((p) =>
      countryIds.map((c) => ({
        email,
        programId: p,
        countryId: c,
      }))
    );
  }

  if (type === UserType.RegionalCoordinator) {
    return programIds.flatMap((p) =>
      countyIds.map((c) => ({
        email,
        programId: p,
        countryId: domesticCountryId,
        stateId,
        countyId: c,
      }))
    );
  }

  // StateCoordinator (and other domestic roles)
  return programIds.map((p) => ({
    email,
    programId: p,
    countryId: domesticCountryId,
    stateId,
  }));
}
